export const APP_VERSION = 'v0.7.0';
export const PRIVACY_POLICY_VERSION = '2026-05-23';

// Cap on secondary reference photos a photo request or an organiser's
// reference set can hold, beyond its one required/primary photo. Kept in
// sync with the backend's MAX_SECONDARY_REFERENCE_PHOTOS
// (cm_backend_utils/photo_access.py) - the server enforces this too, this is
// just so the UI can disable the "+" add-photo tile before hitting a 400.
export const MAX_SECONDARY_REFERENCE_PHOTOS = 5;

// Native background-upload feature: above this many picked Drive files, the
// download phase is unlikely to reliably finish (or safely resume) within
// the Drive access token's ~1hr lifetime, so we don't offer "you can close
// the app" for the download step at all above this count - the picker flow
// falls back to today's foreground-only download+upload instead. See
// EventPage.js's handleDriveFolderSelect/handleDriveSelect.
export const DRIVE_BACKGROUND_MAX_FILES = 100;

// Local-folder auto-sync: `batchSizeSetting` (default 100, see useLocalAutoSync.js)
// is the THRESHOLD that decides when enough new photos have accumulated to be
// worth syncing - it is NOT how many get sent in one go. Without a separate cap,
// arming auto-sync with "include existing" on a folder with thousands of photos
// fragmented into one grouping job PER 100 photos (25 jobs for 2500 photos) -
// each one its own credit hold + EC2-ASG spin-up + full incremental re-grouping,
// which is where the reported "not stable, huge memory/storage usage" behavior
// traced back to. This is the ceiling on a single submission regardless of how
// large the pending backlog is; a bigger backlog still uploads progressively
// underneath (see runOrganiserUploadBatches' own internal compress-then-upload
// sub-batching), it just does so as ONE grouping job
// instead of many.
export const AUTO_SYNC_MAX_BATCH_SIZE = 2000;
